// utils/mapUserData.js
import dayjs from "dayjs";
import { parseStoreWallClockTime } from "./dateFormat";

export const mapPersonalDetails = (res) => {
  const address = res?.addresses?.[0] || {};
  const latlong = address?.latlongs?.[0] || {};

  return {
    fullName: res?.name || "",
    mobile: res?.phone_number || "",
    email: res?.email || "",
    birthDate: res?.dob ? dayjs(res?.dob) : null,
    gender: res?.gender?.toLowerCase() || "",
    address_id: address?.id || "",
    addressLine1: address?.house_no || "",
    addressLine2: address?.street_address || "",
    landmark: address?.landmark || "",
    city: address?.city || "",
    state: address?.state || "",
    zip: address?.zipcode || "",
    latitude: latlong?.latitude || "",
    longitude: latlong?.longitude || "",
    latlong_id: latlong?.id || ""
  };
};


export const mapOtherDetails = (res) => ({
  vechicalType: res?.vehicle_type || "",
  licencePlateNumber: res?.vehicle_number || "",
});

/** Maps first bank row from API into AccountDetails form state. */
export const mapBankDetails = (res) => {
  if (!res) {
    return {
      id: null,
      accountNumber: "",
      accountName: "",
      bankName: "",
      routingNumber: "",
    };
  }
  return {
    id: res.id ?? null,
    accountNumber: res.accountNumber ?? "",
    accountName: res.accountName ?? "",
    bankName: res.bankName ?? "",
    routingNumber: res.routingNumber ?? "",
  };
};

export const mapStoreDetails = (res) => {
  const storeAddress = res.storeAddresses?.[0] || {};

  const storeHoursRaw = res?.store_hours || {};
  // Wall-clock parse so open/close match API strings in the TimePicker (no TZ/DST skew).
  const storeHours = Object.entries(storeHoursRaw).reduce((acc, [day, timeObj]) => {
    const open = timeObj?.open ? parseStoreWallClockTime(timeObj.open) : null;
    const close = timeObj?.close ? parseStoreWallClockTime(timeObj.close) : null;
    acc[day] = {
      open: open?.isValid?.() ? open : null,
      close: close?.isValid?.() ? close : null,
      note: timeObj?.note ?? "",
    };
    return acc;
  }, {});
  const hasStoreHours = Object.values(storeHours).some(
    (val) => val.open || val.close
  );
 
  return {
    id:res.id,
    storeName: res.storeName || "",
    storeContactNumber: res.store_phone || null ,
    storeLicenseNumber: res.licenceNumber || "",
      ...(hasStoreHours && { storeHours: storeHours }),
    address_id:storeAddress?.id || "",
    addressLine1: storeAddress?.house_no || "",
    addressLine2: storeAddress?.street_address || "",
    landmark: storeAddress?.landmark || "",
    city: storeAddress?.city || "",
    state: storeAddress?.state || "",
    zip: storeAddress?.zipcode || "",
    latitude: storeAddress?.latlongs[0]?.latitude || "",
    longitude: storeAddress?.latlongs[0]?.longitude || "",
    latlong_id : storeAddress?.latlongs[0]?.id || "",
  };
};

